import {createNavigation} from "next-intl/navigation";
import {routing} from "./routing";

/**
 * next-intl 기반 다국어 네비게이션 객체 생성
 * - locale 기반 Link
 * - redirect
 * - pathname
 * - router
 * 등을 locale 환경에 맞게 제공
 */
export const {Link, redirect, usePathname, useRouter, getPathname} = createNavigation(routing);